import { merge, share } from "rxjs"
import { leverageInput$, quantity$ } from "./inputs"
import { instrument$ } from "./instrument"

export const formChangeEvents$ = merge(
  instrument$,
  quantity$,
  leverageInput$,
).pipe(share())

// make the stream hot. Needed to prevent emission on subscribe.
formChangeEvents$.subscribe()
